module.exports = __webpack_public_path__ + "static/media/39.b93d388c.jpg";